import { useEffect, useState } from 'react';
import { twilioVoiceService } from '../interpreter-phone/services/TwilioVoiceService';
/**
 * The hearing-party phone leg as the voice service reports it, and its
 * running time. For readers that only show the line (the Tools key); the
 * room owns the calls themselves (Conference.tsx).
 *
 * @returns {{ duration: string, status: CallStatus }}
 */
export default function usePhoneLine() {
    const [status, setStatus] = useState(() => twilioVoiceService.getCallStatus());
    const [duration, setDuration] = useState(() => twilioVoiceService.getCallDuration());
    useEffect(() => {
        const onStatus = (next) => {
            setStatus(next);
            setDuration(twilioVoiceService.getCallDuration());
        };
        const onDuration = (next) => setDuration(next);
        onStatus(twilioVoiceService.getCallStatus());
        twilioVoiceService.on('statusChange', onStatus);
        twilioVoiceService.on('durationUpdate', onDuration);
        return () => {
            twilioVoiceService.off('statusChange', onStatus);
            twilioVoiceService.off('durationUpdate', onDuration);
        };
    }, []);
    return {
        duration,
        status
    };
}
